// Assets
import currenciesFlags from '@/assets/currencies.json';

export default {
  methods: {
    getCurrencyFlag(currencyCode) {
      if (!currencyCode) return '';

      const currency = currenciesFlags.find((c) => c.code === currencyCode.toUpperCase());

      return currency?.flag || '';
    },

    getCurrencyCountry(currencyCode) {
      if (!currencyCode) return '';

      const currency = currenciesFlags.find((c) => c.code === currencyCode.toUpperCase());

      return currency?.country || '';
    },

    getCurrencyCountryPtBr(countryCode) {
      if (!countryCode) return '';

      try {
        const displayNames = new Intl.DisplayNames(['pt-BR'], { type: 'region' });

        return displayNames.of(countryCode.toUpperCase()) || '';
      } catch (error) {
        return this.getCurrencyCountry(countryCode);
      }
    },

    getCountryDisplayName(countryCode) {
      if (!countryCode) return '';

      try {
        const locale = this.$i18n?.locale || 'pt-BR';
        const displayNames = new Intl.DisplayNames([locale], { type: 'region' });

        return displayNames.of(countryCode.toUpperCase()) || '';
      } catch (error) {
        return this.getCurrencyCountry(countryCode);
      }
    },

    formatCurrencyByCode(value, currencyCode) {
      if (value === undefined || value === null) return '-';

      const code = currencyCode || 'USD';

      return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: code });
    },

    getFlagUrl(countryCode) {
      if (!countryCode) return '';

      return `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;
    }
  }
};
